import { FC } from 'react';
import { Modal as AntdModal } from 'antd';
import CreateWatchFaceForm from '../Forms/WatchFace/CreateWatchFaceForm';

interface CreateWatchFaceModalProps {
  setIsOpen: (open: boolean) => void;
  isOpen: boolean;
  watchface?: any;
  defaultCategoryId?: string;
}

const CreateWatchFaceModal: FC<CreateWatchFaceModalProps> = ({ 
  setIsOpen, 
  isOpen, 
  watchface,
  defaultCategoryId 
}) => {
  const handleOk = () => {
    setIsOpen(false);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <>
      {isOpen && (
        <AntdModal
          title='Basic Modal'
          open={isOpen}
          footer={null}
          onCancel={handleCancel}
        >
          <CreateWatchFaceForm
            onCancel={handleCancel}
            onOk={handleOk}
            watchface={watchface}
            isOpen={isOpen}
            defaultCategoryId={defaultCategoryId}
          />
        </AntdModal>
      )}
    </>
  );
};

export default CreateWatchFaceModal;
